const CHECKOUT_ERRORS = {
    BANK_ID_CANCEL: 'BANK_ID_CANCEL',
    DECLINED: 'DECLINED',
    DECLINED_PAYNOVA: 'DECLINED_PAYNOVA',
    GENERIC: 'GENERIC',
    PERSONAL_ID_INVALID: 'PERSONAL_ID_INVALID',
    NotSpecifiedShippingOption: 'NotSpecifiedShippingOption',
    NO_PAYMENT_METHOD: 'No payment method is available.'
};

const CHECKOUT_ERROR_STRINGS = {
    [CHECKOUT_ERRORS.DECLINED_PAYNOVA]:
        'checkout_summary_error_declined_paynova',
    [CHECKOUT_ERRORS.DECLINED]: 'checkout_summary_error_declined',
    [CHECKOUT_ERRORS.GENERIC]: 'checkout_summary_error',
    [CHECKOUT_ERRORS.PERSONAL_ID_INVALID]:
        'checkout_summary_error_personal_id_invalid',
    [CHECKOUT_ERRORS.NotSpecifiedShippingOption]:
        'checkout_summary_error_shipping_non_spec',
    [CHECKOUT_ERRORS.NO_PAYMENT_METHOD]:
        'checkout_summary_error_no_payment_method'
};

const getCheckoutErrorMessage = type => {
    return (
        CHECKOUT_ERROR_STRINGS[type] ||
        CHECKOUT_ERROR_STRINGS[CHECKOUT_ERRORS.GENERIC]
    );
};

export { CHECKOUT_ERRORS, getCheckoutErrorMessage };
